import React, { useState, useEffect, useCallback } from 'react'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import { logout } from '../../../../action/auth-actions'
import { connect } from 'react-redux'
import moment from 'moment'
import Edit from '../../../main-ui/right-toolbar/profile/edit/index'
import EditPassword from '../../../main-ui/right-toolbar/profile/edit/edit-password'
import './index.css'
import ProIcon from '../../../../../asset/pro-icon.png'
import { photoUploadRequest } from '../../../../action/photo-actions'
import { userUpdateRequest } from '../../../../action/user-actions'
import ProfileIcon from '../../../../../asset/default-profile.png'
import SplashScreenLoader from '../../../../../asset/loading-spinner.gif'
import CancelSubscription from './cancelRenewal'
import { cancelUserSubscription } from '../../../../action/user-actions'
import { showHideSubscriptionModal } from '../../../../utils/subscriptionUtils'
import { locationClearTimeOut } from '../../../../action/friends-location-action'
import UpgradeSubscription from './upgradeModelPopup'
import ReusableButton from '../../../recreationAccess/reusableComponents/button/customButton'
import { openManageSubscription, closeManageSubscription } from '../../../../action/manage-subscription'
import LandingPage from '../../left-toolbar/subscription'
import { closeAssignSubscription } from '../../../../action/sub-showAssigne-action'
import CancelPopUp from '../subscription/cancelPopUp'
import { fetchAssignedSubscription, cancelAssignedSubscription } from '../../../../action/subscription-api'
import CancelSubscriptionSuccess from './cancelSuccess'
import { userFetchRequest } from '../../../../action/user-actions'
import { getPurchasedSubscription } from '../../../../lib/util'

const Profile = (props) => {
  // The user's paid plan, resolved by plan id rather than array position. The subscription list
  // is not guaranteed to be ordered free-then-paid, so indexing (e.g. userSubscription[1]) breaks
  // whenever the paid plan is not the second element.
  const purchasedPlan = getPurchasedSubscription(props.user?.userSubscription)
  const [editProfile, setEditProfile] = useState(true)
  const [editPassword, setEditPassword] = useState(false)
  const [loadSpinner, setLoadSpinner] = useState(false)
  const [cancelSubscription, setCancelSubscription] = useState(false)
  const [subscriptionPlanIdState, setsubscriptionPlanIdState] = useState()
  const [imageValue, setImageValue] = useState(props.user.imageProfileUrl ? props.user.imageProfileUrl : ProfileIcon)
  const [ifGroupSubgiven, setIfGroupSubgiven] = useState(false)
  const [cancelGroupSubscription, setCancelGroupSubscription] = useState(false)
  const [assignedSubscription, setAssignedSubscription] = useState(props.subscriptionAssigned)
  const [loader, setLoader] = useState(true)
  const [cancelGroupSubscriptionSuccess, setCancelGroupSubscriptionSuccess] = useState(false)

  const [userData, setUserData] = useState(purchasedPlan?.assignedSubscription)

  const [modelVisible, setModelVisible] = useState(false)
  let inputEle = React.createRef()
  const { hidePopout, expandRightToolbar, collapseLeftToolbar, user, logout, subscriptionPlans, locationTimeInterval, locationClearTimeOut } = props,
    userImage = user.imageProfileUrl ? user.imageProfileUrl : '../../../../asset/default-profile.png'


  useEffect(() => {
    props.closeManageSubscription()
    props.closeAssignSubscription()
  }, [])
  useEffect(() => {
    // setImageValue(user.imageProfileUrl)
    getProfileIcon(user.imageProfileUrl)
  }, [user])


  useEffect(() => {

    setAssignedSubscription(props.subscriptionAssigned)

  }, [props.subscriptionAssigned])

  useEffect(() => {
    purchasedPlan?.id &&
      props.fetchAssignedSubscription(purchasedPlan?.id)
        .then((res) => {
          setAssignedSubscription(res)
          setLoader(false)
        })
        .catch((err) => {
          setLoader(false)
        })
  }, [])


  useEffect(() => {
    imageValue && setTimeout(() => {
      setLoadSpinner(false)
    }, 1500)
  }, [imageValue])

  let subValue = user.userSubscription.map(items => {
    let values = []
    let filterValue = subscriptionPlans.filter(value => {
      if (items.subscriptionPlanId == value.id) {
        values.push({ userSubscription: items, subscriptionPlan: value })
      }
    })
    return values
  })
  let updatePhoto = (e) => {
    e.preventDefault()
    inputEle.current.click()
  }

  let logoutFunction = (e) => {
    logout()
    // locationTimeInterval
    console.log('helo stopped')
    if (locationTimeInterval) {
      clearInterval(locationTimeInterval);
      // this.timeInterval = null;
      locationClearTimeOut(null)
    }
  }


  let onStripeSubscription = () => {
    const url = `${__API_URI__}/Payment/BillingLink`;
    const token = props.auth.token;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
      }
    })
      .then(async (response) => {
        const data = await response.json();
        console.log("Billing Link Response:", data);

        if (response.status === 200) {
          window.open(data);
        } else {
          console.error("Non-200 status:", response.status, data);
        }
      })
      .catch(error => {
        console.error("Error fetching billing link:", error);
      });
  };


  let handlePhotoUpload = (e) => {
    const { photoUploadRequest, userUpdateRequest, user } = props,
      file = e.target.files[0]
    setLoadSpinner(true)
    if (file) {
      let data = new FormData()
      data.append('file', file)
      let photoInfo = {
        typeId: 2,
        activityId: 1
      }
      photoInfo = JSON.stringify(photoInfo)
      data.append('photoInfo', photoInfo)
      photoUploadRequest(data).then(res => {
        let userInfo = Object.assign({}, user)
        userInfo.photoId = res.id
        delete userInfo.password
        userUpdateRequest(userInfo)
          .then(() => {
            console.log('User Photo Updated')
          })
          .catch((err) => {
            setLoadSpinner(false)
            console.error('User Photo Update Failed: ', err)
          })
      })
    }
  }
  let cancelRenewal = (subscriptionPlanId) => {
    setCancelSubscription(true)
    setsubscriptionPlanIdState(subscriptionPlanId)
  }

  let cancelSubscriptionfunction = () => {
    props.cancelUserSubscription(subscriptionPlanIdState, (res) => {
      if (res.statusCode == 1000) {
        setCancelSubscription(false)
      } else if (res.statusCode == 8888) {
        setCancelSubscription(false)
        alert('Subscrition renewal cancel is not cancelled')
      }
    });
  };

  let getProfileIcon = (imageUrl) => {
    let userImageVal
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      userImageVal = img.src;
      setImageValue(userImageVal)
      return userImageVal
    };

    img.onerror = () => {
      userImageVal = '../../../../asset/default-profile.png';
      setImageValue(userImageVal)
      return userImageVal
    };
  }

  let handleClick = () => {
    const shouldOpenManageSubscription = props.userSubscription.some(
      (item) => item.quantity > 1
    );

    if (shouldOpenManageSubscription) {
      props.openManageSubscription();
    }
  }

  let handleOpenCancleSub = () => {
    setUserData(purchasedPlan?.assignedSubscription)
    setCancelGroupSubscription(true)
  }

  let closeSuccessMenu = useCallback(() => {
    setCancelGroupSubscriptionSuccess(false);
  }, [cancelGroupSubscriptionSuccess]);

  let confirmRemove = useCallback(() => {
    let userSubId = purchasedPlan?.id,
      userId = props.user.id
    // userId, userSubId 
    props.cancelAssignedSubscription({ userId, userSubId })
      .then((res) => {
        props.userFetchRequest()
        setCancelGroupSubscription(false)
        setIfGroupSubgiven(true)
        setCancelGroupSubscriptionSuccess(true)
      })
      .catch((err) => {
        alert('Cancel Failed')
        setCancelGroupSubscription(false)
      })

  }, [cancelGroupSubscription, ifGroupSubgiven, cancelGroupSubscriptionSuccess])

  return (
    <div className='left-expanded-profile-container'>
      {editProfile ? <>
        <div style={{ width: 440 - 78, height: '100vh', boxSizing: 'border-box', display: 'flex', flexWrap: 'wrap', transition: 'width 1s ease' }}>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div className='left-expanded-header-container'>
              <span className='left-expanded-header'>My Account</span>
              <div className='default-close left-dialog-close' onClick={collapseLeftToolbar}></div>
            </div>
            <div className="parent-grid-container">
              <div className="grid-container">


                <div className="grid-item">
                  <div className='left-extended-profile'>

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <div style={{ position: 'relative', border: '3px solid #6E6E6E', width: 100, height: 100, borderRadius: '50%', marginTop: 10, marginBottom: 10 }}>
                        {/* Overlay Icon */}
                        {user.isPro &&
                          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            <img src={ProIcon} style={{ position: 'absolute', bottom: -14, width: 42, height: 34, zIndex: 2 }} alt='Pro Icon' />
                          </div>}
                        <div style={{ position: 'relative', display: 'inline-block' }}>
                          {loadSpinner && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                color: 'white',
                                zIndex: 1
                              }}
                            >
                              {/* Add your loader component here */}
                              <img src={SplashScreenLoader} style={{ width: '30px', height: '30px' }}></img>
                            </div>
                          )}
                          <img
                            src={imageValue}
                            style={{
                              width: 100,
                              height: 100,
                              borderRadius: '50%',
                              filter: loadSpinner ? 'blur(1px)' : 'none',
                            }}
                            alt="Profile Image"
                          />
                        </div>
                      </div>
                    </div>
                    <div className='profile-image-upload-container'>
                      <p style={{ textDecoration: 'underline', cursor: 'pointer', userSelect: 'none' }} onClick={updatePhoto}>Change Image</p>
                      <input type='file' accept='image/*' ref={inputEle} style={{ display: 'none' }} onChange={handlePhotoUpload}></input>
                    </div>
                    <div style={{ textAlign: 'center', height: '7em' }}>
                      <h1 className="profile-text">{user.fullName}</h1>
                      <p className="profile-text">{user.email}</p>
                      <p className="profile-text-grey">Member since&nbsp;:&nbsp;{moment(user.created).format('MM-DD-YYYY')}</p>
                      <p className="profile-text-grey">{user.phone}</p>
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <ReusableButton
                        className='lets-go-button-label'
                        label={'EDIT PROFILE'}
                        onClick={() => setEditProfile(false)}
                        variant={"primary"}
                        size="small"
                        buttonWidth='200px'
                        buttonHeight="38px"
                        buttonColor={"#333333"}
                        borderColor={'#589500'}
                      >
                      </ReusableButton>
                    </div>

                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: 20 }}>
                      <div>
                        <a style={{ color: '#A49E9E' }}>
                          <p style={{ textDecoration: 'underline' }} onClick={() => {
                            setEditPassword(true)
                            setEditProfile(false)
                          }}>Update Password</p>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="grid-item"></div>
                {
                  purchasedPlan?.quantity > 1 || purchasedPlan?.assignedSubscription ?
                    // {/* group subscription */}
                    <div className="grid-item">
                      <div className='left-toolbar-profile-container'>
                        <div style={{ width: '100%', height: 10 }}></div>
                        <div className="card-header">
                          <p style={{ font: 'normal normal normal 20px/26px Roboto', textAlign: 'center' }}> Subscriptions </p>
                        </div>

                        {props.user.isPro && !purchasedPlan?.assignedSubscription ?
                          <>

                            {

                              !purchasedPlan?.assignedSubscription && subValue.length > 1 ?
                                <div className='no-membership-container'>

                                  {!purchasedPlan?.cancelDate ?
                                    <>
                                      <p className='sub-renew-text'>Renews&nbsp;&nbsp;
                                        <span>
                                          {
                                            (() => {
                                              const raw = assignedSubscription?.expires?.trim() || '';
                                              const date = moment(raw); // no format, no strict mode
                                              return date.isValid() ? date.format('MM-DD-YYYY') : '';
                                            })()
                                          }
                                        </span>
                                      </p>

                                      <div>
                                        <p className='group-sub-cancel' onClick={() => { cancelRenewal(assignedSubscription.userSubscriptionId) }}> CANCEL </p>
                                      </div>
                                    </>
                                    :
                                    <>
                                      <p className='sub-renew-text'>Expires&nbsp;&nbsp;
                                        <span>
                                          {
                                            (() => {
                                              const raw = purchasedPlan?.expDate?.trim() || '';
                                              const date = moment(raw); // no format, no strict mode
                                              return date.isValid() ? date.format('MM-DD-YYYY') : '';
                                            })()
                                          }
                                        </span>
                                      </p>
                                    </>
                                  }

                                  <div>
                                    <p className='group-sub-cancel'>  </p>
                                  </div>
                                  <div className='subscription-plans' >
                                    <div className='subscription-plans-container'>
                                      <p className='sub-p-heading'>Active :</p>
                                      <p className='sub-p-value'>{assignedSubscription?.quantity && (assignedSubscription?.quantity)}</p>
                                    </div>

                                    <div className='subscription-plans-container'>
                                      <p className='sub-p-heading'>Open :</p>
                                      <p className='sub-p-value'>{assignedSubscription?.unassigned}</p>
                                    </div>



                                    <ReusableButton
                                      className='lets-go-button-label'
                                      label={'MANAGE'}
                                      onClick={handleClick}
                                      variant={"primary"}
                                      size="small"
                                      buttonWidth='200px'
                                      buttonHeight="38px"
                                      buttonColor={"#333333"}
                                      borderColor={'#589500'}
                                    >
                                    </ReusableButton>
                                  </div>
                                </div>
                                :
                                <div className='no-membership-container'>
                                  <h3> Subscription via:</h3>
                                  <h3>{purchasedPlan?.assignedSubscription?.assignedByName}</h3>
                                  <h3>{purchasedPlan?.assignedSubscription?.assignedByEmail}</h3>
                                  <h2>Pro{purchasedPlan?.subscriptionPlanId == 44 ? 'Pro Ultimate' : purchasedPlan?.subscriptionPlanId == 36 ? 'Pro Advantage' : 'Pro'}</h2>
                                  <h3>Assigned Date:
                                    {
                                      (() => {
                                        const raw = purchasedPlan?.assignedSubscription?.dateAssigned.trim() || '';
                                        const date = moment(raw); // no format, no strict mode
                                        return date.isValid() ? date.format('MM-DD-YYYY') : 'Invalid';
                                      })()
                                    }
                                  </h3>

                                  <ReusableButton
                                    className='lets-go-button-label'
                                    label={'Cancel'}
                                    onClick={handleOpenCancleSub}
                                    variant={"primary"}
                                    size="small"
                                    buttonWidth='100px'
                                    buttonHeight="38px"
                                    buttonColor={"#333333"}
                                    borderColor={'#70716F'}
                                  >
                                  </ReusableButton>
                                </div>
                            }
                          </>
                          :

                          // !props.user?.userSubscription[1]?.assignedSubscription ?
                          !props.user.isPro ?
                            <div className='no-membership-container'>
                              <h3>Basic Account Free</h3>
                              <button className='membership-upgeade-button'
                                onClick={() => { showHideSubscriptionModal(props.auth.token) }}
                              >UPGRADE</button>
                            </div>
                            :
                            <div className='no-membership-container'>
                              <h3> Subscription via:</h3>
                              <h3>{purchasedPlan?.assignedSubscription?.assignedByName}</h3>
                              <h3>{purchasedPlan?.assignedSubscription?.assignedByEmail}</h3>
                              <h2>{purchasedPlan?.subscriptionPlanId == 44 ? 'Pro Ultimate' : purchasedPlan?.subscriptionPlanId == 36 ? 'Pro Advantage' : 'Pro'}</h2>

                              <h3>Assigned :&nbsp;
                                {
                                  (() => {
                                    const raw = purchasedPlan?.assignedSubscription?.dateAssigned.trim() || '';
                                    const date = moment(raw); // no format, no strict mode
                                    return date.isValid() ? date.format('MM-DD-YYYY') : 'Invalid';
                                  })()
                                }
                              </h3>

                              <ReusableButton
                                className='lets-go-button-label'
                                label={'Cancel'}
                                onClick={handleOpenCancleSub}
                                variant={"primary"}
                                size="small"
                                buttonWidth='100px'
                                buttonHeight="38px"
                                buttonColor={"#333333"}
                                borderColor={'#70716F'}
                              >
                              </ReusableButton>
                            </div>

                        }

                      </div>
                    </div>

                    :
                    <>
                      {/* <div className="grid-item" style={{ height: '50px' }}></div> */}

                      {/* to show the list of subscription  */}
                      <div className="grid-item">
                        <div className='left-toolbar-profile-container'>
                          <div style={{ width: '100%', height: 10 }}></div>
                          <div className="card-header">
                            <p style={{ font: 'normal normal normal 20px/26px Roboto', textAlign: 'center' }}>Membership Subscriptions </p>
                          </div>
                          <div style={{ display: 'flex', justifyContent: 'center', width: "100%", paddingBottom: 20 }}>
                            {/* <table className='table-profile'>
                              <>{subValue.length > 1 ?
                                <>
                                  {subValue.map((item, i) => {
                                    return (
                                      <div key={i}>
                                        {item && item[0] && item[0].subscriptionPlan.id != 1 ?
                                          <div className='table-container'>
                                            <tr>
                                              <td className='td-profile-name'>{item[0].subscriptionPlan.name === "Pro Bundle" ? 'Pro Ultimate' : item[0].subscriptionPlan.name}</td>


                                              {!item[0].userSubscription.cancelDate && <td className='td-profile-exp'>
                                                <p style={{ fontSize: 12 }}>Renews:&nbsp;</p>
                                                <p style={{ fontSize: 12 }}>{moment(item[0].userSubscription.expDate).format('MM-DD-YYYY')}</p>
                                              </td>}
                                            </tr>
                                            <tr>
                                              <td className='td-profile-created-on'>Created on: {item[0].userSubscription.platformId === 1 ? 'Android' : item[0].userSubscription.platformId === 2 ? 'iOS' : item[0].userSubscription.platformId === 3 ? 'Web' : item[0].userSubscription.platformId >= 4 ? 'Other' : 'Other'}</td>
                                              {item[0].userSubscription.platformId === 3 && !item[0].userSubscription.cancelDate ?

                                                __NODE_ENV__ == "production"
                                                  ?
                                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }} onClick={onStripeSubscription}>
                                                    <a href="#" className="edit-profile-btn" style={{ width: '120px', height: '20px', fontSize: 12 }}>
                                                      Manage Subscription
                                                    </a>
                                                  </div>
                                                  :
                                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }} onClick={onStripeSubscription}>
                                                    <a href="#" className="edit-profile-btn" style={{ width: '120px', height: '20px', fontSize: 12 }}>
                                                      Manage Subscription
                                                    </a>
                                                  </div>

                                                : item[0].userSubscription.cancelDate &&
                                                <td className='td-profile'>
                                                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: 130 }} >
                                                    <p style={{ fontSize: 12 }}>Expires on:&nbsp;</p>
                                                    <p style={{ fontSize: 12 }}>{moment(item[0].userSubscription.cancelDate).format('MM-DD-YYYY')}</p>
                                                  </div>



                                                </td>
                                              }


                                            </tr>
                                          </div>
                                          : ' '}
                                      </div>
                                    )
                                  })}
                                </>
                                :
                                <div className='no-membership-container'>
                                  <h3>No Memberships</h3>
                                  <button className='membership-upgeade-button'
                                    onClick={() => { showHideSubscriptionModal(props.auth.token) }}
                                  >UPGRADE</button>
                                </div>
                              }
                              </>
                            </table> */}


                            <table className='table-profile'>
                              <tbody>
                                {subValue.length > 1 ? (
                                  subValue.map((item, i) => {
                                    if (!item || !item[0] || item[0].subscriptionPlan.id === 1) return null;

                                    return (
                                      <React.Fragment key={i}>
                                        <tr>
                                          <td className='td-profile-name'>
                                            {item[0].subscriptionPlan.name === "Pro Bundle"
                                              ? 'Pro Ultimate'
                                              : item[0].subscriptionPlan.name}
                                          </td>

                                          {!item[0].userSubscription.cancelDate && (
                                            <td className='td-profile-exp'>
                                              <p style={{ fontSize: 12 }}>Renews:&nbsp;</p>
                                              <p style={{ fontSize: 12 }}>
                                                {moment(item[0].userSubscription.expDate).format('MM-DD-YYYY')}
                                              </p>
                                            </td>
                                          )}
                                        </tr>

                                        <tr>
                                          <td className='td-profile-created-on'>
                                            Created on: {
                                              item[0].userSubscription.platformId === 1 ? 'Android' :
                                                item[0].userSubscription.platformId === 2 ? 'iOS' :
                                                  item[0].userSubscription.platformId === 3 ? 'Web' : 'Other'
                                            }
                                          </td>

                                          {item[0].userSubscription.platformId === 3 &&
                                            !item[0].userSubscription.cancelDate && (
                                              <td>
                                                <a
                                                  href="#"
                                                  className="edit-profile-btn"
                                                  style={{ width: 120, height: 20, fontSize: 12 }}
                                                  onClick={onStripeSubscription}
                                                >
                                                  Manage Subscription
                                                </a>
                                              </td>
                                            )}

                                          {item[0].userSubscription.cancelDate && (
                                            <td className='td-profile'>
                                              <p style={{ fontSize: 12 }}>
                                                Expires on: {moment(item[0].userSubscription.expDate).format('MM-DD-YYYY')}
                                              </p>
                                            </td>
                                          )}
                                        </tr>
                                      </React.Fragment>
                                    );
                                  })
                                ) : (
                                  <tr>
                                    <td colSpan={2} className='no-membership-container'>
                                      <h3>No Memberships</h3>
                                      <button
                                        className='membership-upgeade-button'
                                        onClick={() => showHideSubscriptionModal(props.auth.token)}
                                      >
                                        UPGRADE
                                      </button>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>



                          </div>
                        </div>
                      </div>
                    </>
                }

              </div>
            </div>
            <div className='container-profile'>
              <div className='logout-button-container'>
                <button className='logout-button' style={{}} onClick={logoutFunction}>Logout</button>
              </div>
            </div>
          </div>
        </div>

        {props.manageSubscription ? <LandingPage assignedSubscription={assignedSubscription} loader={loader}></LandingPage> : null}
      </> :
        editPassword ?
          <EditPassword fromLeftBar={true} cancelEdit={() => {
            setEditPassword(false)
            setEditProfile(true)
          }} ></EditPassword>
          :
          <Edit cancelEdit={() => {
            setEditProfile(true)
          }} />
      }

      {cancelSubscription ?
        <>
          <CancelSubscription
            remove={() => cancelSubscriptionfunction()}
            cancel={() => setCancelSubscription(false)}>
          </CancelSubscription>
        </> : null
      }

      {cancelGroupSubscription ?
        <CancelPopUp
          title={'Cancel your subscription from:'}
          cancel={() => { setCancelGroupSubscription(false) }}
          cancelSubscriptionData={{
            fullName: purchasedPlan?.assignedSubscription?.assignedByName,
            email: purchasedPlan?.assignedSubscription?.assignedByEmail
          }}
          remove={() => {
            confirmRemove()
          }}
        ></CancelPopUp>
        :
        null}

      {cancelGroupSubscriptionSuccess ?
        <CancelSubscriptionSuccess
          cancelSubscriptionData={{
            fullName: userData?.assignedByName,
            email: userData?.assignedByEmail
          }}
          userData={userData}
          closeMenu={() => {
            closeSuccessMenu()
          }}
        ></CancelSubscriptionSuccess>
        :
        null}

    </div>
  )
}

const mapStateToProps = state => ({
  user: state.user,
  subscriptionPlans: state.subscriptionPlans,
  auth: state.auth,
  locationTimeInterval: state.locationTimeInterval,
  manageSubscription: state.manageSubscription,
  userSubscription: state.userSubscription,
  subscriptionAssigned: state.subscriptionAssigned
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  logout: () => dispatch(logout()),
  expandRightToolbar: props => dispatch(expandRightToolbar(props)),
  photoUploadRequest: data => dispatch(photoUploadRequest(data)),
  userUpdateRequest: data => dispatch(userUpdateRequest(data)),
  cancelUserSubscription: (data, cb) => dispatch(cancelUserSubscription(data, cb)),
  locationClearTimeOut: (payload) => dispatch(locationClearTimeOut(payload)),
  openManageSubscription: () => dispatch(openManageSubscription()),
  closeManageSubscription: () => dispatch(closeManageSubscription()),
  closeAssignSubscription: () => dispatch(closeAssignSubscription()),
  fetchAssignedSubscription: (payload) => dispatch(fetchAssignedSubscription(payload)),
  cancelAssignedSubscription: ((payload) => dispatch(cancelAssignedSubscription(payload))),
  userFetchRequest: () => dispatch(userFetchRequest())
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)